import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import commonFunctions from '../../../../commonFunctions';

const WarrantyAllowanceModal = ({ authenticationState, warranty, warrantyAllowanceModalShow, warrantyCoverageCap, toggle,
    warrantyAllowanceDelete, warranttAllowanceInsert }) => {

    function insertButton() {
        return (<button type="button" className="btn btn-info react-bs-table-add-btn " onClick={warranttAllowanceInsert}>
            <span><i className="glyphicon glyphicon-plus"></i>Aggiungi</span>
        </button>);
    }

    function warrantyWithDiscount(cell, row) {
        return commonFunctions.numberToItalianEuroFormat(warrantyCoverageCap.annualNetValue * (100 - row.percentageDiscount) / 100);
    }

    function warrantyAllowanceConfirmDelete(next, dropRowKeys) {
        // eslint-disable-next-line
        if (confirm(`Sei sicuro di voler eliminare le Franchigie selezionate?`)) {
          next();
      }
    }

    function numberToItalianFormat(value) {
        return _.toString(_.toNumber(value).toFixed(2)).replace('.', ',');
    }

    const gridOptions = {
        deleteText: 'Elimina',
        handleConfirmDeleteRow: warrantyAllowanceConfirmDelete,
        onDeleteRow: warrantyAllowanceDelete,
        insertBtn: insertButton
    };

    const cellEditProp = {
        mode: 'click',
        blurToSave: true
    };

    return (
        <Modal show={warrantyAllowanceModalShow} onHide={toggle}>
            <Modal.Header closeButton>
                <Modal.Title>Valore Netto: {commonFunctions.numberToItalianEuroFormat(warrantyCoverageCap.annualNetValue)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <BootstrapTable data={warrantyCoverageCap.warrantyAllowances} options={gridOptions} cellEdit={cellEditProp}
                    selectRow={warranty.lockedOut ? {} : { mode: 'checkbox' }} deleteRow={!warranty.lockedOut} insertRow={!warranty.lockedOut}
                    striped hover pagination>
                    <TableHeaderColumn dataField='id' isKey hidden>Id</TableHeaderColumn>
                    <TableHeaderColumn dataField='allowance' dataSort editable={!warranty.lockedOut} dataFormat={commonFunctions.numberToItalianEuroFormat}>Franchigia</TableHeaderColumn>
                    <TableHeaderColumn dataField='uncovered' dataSort editable={!warranty.lockedOut} dataFormat={numberToItalianFormat}>Scoperto %</TableHeaderColumn>
                    <TableHeaderColumn dataField='percentageDiscount' dataSort editable={!warranty.lockedOut} dataFormat={numberToItalianFormat}>Sconto %</TableHeaderColumn>
                    <TableHeaderColumn dataField='warrantyWithDiscount' dataSort editable={false} dataFormat={warrantyWithDiscount}>Prestazione Scontata</TableHeaderColumn>
                </BootstrapTable>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={toggle}>Chiudi</Button>
            </Modal.Footer>
        </Modal>
    );
};

WarrantyAllowanceModal.propTypes = {
    authenticationState: PropTypes.object.isRequired,
    warranty: PropTypes.object.isRequired,
    warrantyAllowanceModalShow: PropTypes.bool.isRequired,
    warrantyCoverageCap: PropTypes.object.isRequired,
    toggle: PropTypes.func.isRequired
};

export default WarrantyAllowanceModal;